import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import ApartmentCard from '../components/ApartmentCard';
import { apartmentsData, benefits } from '../data/apartments';

const ApartmentsSection = styled.section`
  padding: 6rem 0;
  background: white;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: ${props => props.theme.colors.secondary};
`;

const ApartmentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const BenefitsSection = styled.section`
  padding: 5rem 0;
  background: ${props => props.theme.colors.light};
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const BenefitCard = styled(motion.div)`
  background: white;
  padding: 2rem;
  border-radius: ${props => props.theme.borderRadius.large};
  box-shadow: ${props => props.theme.shadows.medium};
  text-align: center;
`;

const Home = () => {
  return (
    <main>

      <ApartmentsSection id="apartments">
        <SectionTitle>Nasze Apartamenty</SectionTitle>

        <ApartmentsGrid>
          {apartmentsData.map((apartment, index) => (
            <ApartmentCard 
              key={apartment.id} 
              apartment={apartment} 
              index={index}
            />
          ))}
        </ApartmentsGrid>

      </ApartmentsSection>

      <BenefitsSection>

        <SectionTitle>
          Dlaczego warto wybrać nasze apartamenty?
        </SectionTitle>

        <BenefitsGrid>

          {benefits.map((benefit, index) => (

            <BenefitCard
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
            >

              <span style={{fontSize:"2.5rem"}}>{benefit.icon}</span>

              <h3>{benefit.title}</h3>

              <p>{benefit.description}</p>

            </BenefitCard>

          ))}

        </BenefitsGrid>

      </BenefitsSection>

    </main>
  );
};

export default Home;